<template>
	<div :id="'review-'+identify" class="review-box hide mt-3">
		<div class="row review-content p-3">
			<div class="col-3 col-sm-2 my-2 review-icon-area">
				<i class="fa fa-info-circle review-icon"></i>
			</div>
			<div class="col-9 col-sm-10 my-2">
				<p class="header-review h3">{{header_msg}}</p>
				<p>{{main_msg}}</p>
			</div>
		</div>
		<!-- <i class="fa fa-quote-right bg-quote"></i> -->
		<div class="review-box-progress">
			<div class="review-box-progress-val"></div>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			header_msg: '',
			main_msg: ''
			// number: []
		}
	},
	props: ['stat', 'reso', 'progress', 'identify'],
	methods: {
		setData(){
			let color = ''
			let background = ''
			if (this.progress === 0) {
				color = '#9E9E9E'
				background = '#333333'
			} else if (this.progress <= 40) {
				color = '#FF6969'
				background = '#514242'
			} else if (this.progress <= 80) {
				color = '#FFA400'
				background = 'rgb(84,75,64)'
			} else if (this.progress < 100) {
				color = '#5374FA'
				background = '#373e57'
			} else if (this.progress === 100) {
				color = '#0CCE6B'
				background = '#3b5347'
			}

			let id = 'review-'+this.identify
			document.getElementById(id).style.background = background
			document.querySelector('#'+id+' .review-icon').style.color = color
			document.querySelector('#'+id+' .header-review').style.color = color
			document.querySelector('#'+id+' .review-box-progress-val').style.background = color
			document.querySelector('#'+id+' .review-box-progress-val').style.width = this.progress+'%'

			let progress_num = this.reso - this.stat

			let header_msg = ''
			let main_msg = ''
			let n = this.getName()

			let cur_date = new Date()
			let target_date = new Date('2021-12-31')
			let day_diff = parseInt((target_date - cur_date)/(1000*60*60*24))

			if (this.progress === 0) {
				header_msg = 'Belum memulai?'
				main_msg = 'Progress untuk ' + n.name_c + ' anda 0%. Ayo lebih semangat lagi!. Waktu tersisa lagi ' + day_diff + ' hari.'
			} else if (this.progress <= 40) {
				header_msg = 'Baru memulai? Tidak masalah!'
				main_msg = 'Dengan konsisten, anda pasti bisa mencapai target jumlah '+n.name_c+'. Memang masih banyak :) tapi percayalah, ' + day_diff + ' hari adalah waktu yang lebih dari cukup untuk mencapai target.'
			} else if (this.progress <= 80) {
				header_msg = 'Semangat! Perjalanan masih panjang'
				main_msg = 'Anda perlu membuat setidaknya ' + progress_num + ' ' + n.name_c + ' untuk mencapai resolusi. Tapi tenang, waktu masih panjang. Masih tersisa ' + day_diff + ' hari lagi sebelum menutup tahun 2021.'
				
			} else if (this.progress < 100) {
				header_msg = 'Resolusi anda hampir tercapai!'
				main_msg = 'Sedikit lagi! Tinggal ' + progress_num + ' ' + n.name_c + ' saja resolusi anda terpenuhi. Santai sejenak tidak masalah. Masih ada waktu ' + day_diff + ' hari.'
			} else if (this.progress === 100) {
				header_msg = 'Selamat! Anda sudah bekerja keras'
				main_msg = 'Resolusi jumlah '+n.name_c+' sudah tercapai. Anda membuktikan resolusi yang anda atur pada awal tahun bisa direalisasikan. Sekali lagi selamat!'
			}
			this.header_msg = header_msg
			this.main_msg = main_msg
		},
		getName(){
			let name = ''
			let name_c = ''
			if(this.identify == 'repo'){
				name = 'Repository'
				name_c = 'repository'
			} else if(this.identify == 'commit') {
				name = 'Commit'
				name_c = 'commit'

			} else if(this.identify == 'star') {
				name = 'Star'
				name_c = 'star'

			} else if(this.identify == 'fork') {
				name = 'Fork'
				name_c = 'fork'

			} else if(this.identify == 'follower') {
				name = 'Follower'
				name_c = 'follower'

			} else if(this.identify == 'pull_req') {
				name = 'Pull Request'
				name_c = 'pull request'
			}
			return {name: name, name_c: name_c}
		}
	},
	mounted(){
		setTimeout(() => {
			this.setData()
			document.getElementById('review-'+this.identify).classList.remove('hide')
		}, 2000)
	}
}
</script>

<style>
	.review-box {
		position: relative;
		overflow: hidden;
		background: rgba(255,255,255,.4);
		width: 100%;
		border-radius: 20px;
		opacity: 1;
		transition: opacity .3s;
	}
	.review-box.hide {
		opacity: 0;
	}
	.review-content {
		width: 100%;
		z-index: 9;
	}
	.review-icon-area {
		text-align: right;
	}
	.review-icon {
		font-size: 5rem;
	}
	.review-box-progress {
		width: 100%;
		height: 2px;
		background: transparent;
	}
	.review-box-progress-val {
		height: 2px;
	}
	@media screen and (max-width: 767px){
		.review-icon {
			font-size: 3rem;
		}
	}
	@media screen and (max-width: 577px){
		.review-icon-area {
			text-align: left;
		}
	}
</style>